import { useState } from "react";

import { addYears } from "date-fns";

import { Box, Flex } from "@/components/layout/flexbox";
import { CalendarIcon } from "@/components/pages_logged_in/program/components/set-components/configure-inputs/CalendarIcon";
import { DateTimeInputV2 } from "@/components/pieces/DateTimeInputV2";
import { StandaloneCheckbox } from "@/components/pieces/form/StandaloneCheckbox";
import { Subtext } from "@/components/pieces/form/Subtext";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { getBrowserTimezone } from "@/utils/datetime";

interface SchedulingFormProps {
  description?: string;
  isSchedule: boolean;
  scheduleTime?: string | null;
  onChangeScheduleTime: (datetime: string | null) => void;
  onToggleSchedule: (isSchedule: boolean) => void;
}

export function SchedulingForm({
  description = "Schedule time to send invitations and grant credits",
  isSchedule,
  scheduleTime,
  onChangeScheduleTime,
  onToggleSchedule,
}: SchedulingFormProps) {
  const [timezone, setTimezone] = useState(getBrowserTimezone());

  return (
    <Flex flexDirection="column" style={{ gap: 8 }}>
      <Flex>
        <StandaloneCheckbox
          onChange={() => {
            onToggleSchedule(!isSchedule);
          }}
          checked={isSchedule}
        />
        <Clickable onClick={() => onToggleSchedule(!isSchedule)}>
          <Subtext style={{ fontSize: 16 }} ml={2}>
            {description}
          </Subtext>
        </Clickable>
      </Flex>
      {isSchedule && (
        <Box css={{ position: "relative" }}>
          <CalendarIcon />
          <DateTimeInputV2
            value={scheduleTime}
            onChange={onChangeScheduleTime}
            onChangeTimezone={setTimezone}
            timezone={timezone}
            minDateTime={new Date()}
            maxDateTime={addYears(new Date(), 1)}
          />
        </Box>
      )}
    </Flex>
  );
}
